/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner } from './save-deal-with-journalizing200-response-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealWithJournalizing200ResponseIntegratedBy } from './save-deal-with-journalizing200-response-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealWithJournalizing200ResponseInvoiceIssuer } from './save-deal-with-journalizing200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealWithJournalizing200ResponseJournalEntriesInner } from './save-deal-with-journalizing200-response-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealWithJournalizing200ResponseJournalizedBy } from './save-deal-with-journalizing200-response-journalized-by';

/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200Response
 */
export interface SaveDealWithJournalizing200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'status': SaveDealWithJournalizing200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseJournalizedBy}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalizedBy': SaveDealWithJournalizing200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseIntegratedBy}
     * @memberof SaveDealWithJournalizing200Response
     */
    'integratedBy': SaveDealWithJournalizing200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealWithJournalizing200ResponseJournalEntriesInner>}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalEntries': Array<SaveDealWithJournalizing200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealWithJournalizing200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseInvoiceIssuer}
     * @memberof SaveDealWithJournalizing200Response
     */
    'invoiceIssuer': SaveDealWithJournalizing200ResponseInvoiceIssuer | null;
}

export const SaveDealWithJournalizing200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealWithJournalizing200ResponseStatusEnum = typeof SaveDealWithJournalizing200ResponseStatusEnum[keyof typeof SaveDealWithJournalizing200ResponseStatusEnum];


